module.exports = __webpack_public_path__ + "img/banner3_5.0f2af1e4.png";